function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgElo = function SvgElo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#0F0F12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.232 6c5.642 0 10.215 4.574 10.215 10.215 0 5.642-4.573 10.216-10.215 10.216-5.642 0-10.215-4.574-10.215-10.216C6.017 10.574 10.59 6 16.232 6z",
    fill: "#0F0F12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.19 15.43l-3.136 1.35a1.796 1.796 0 013.136-1.351zm-1.347-1.953a3.14 3.14 0 013.052 2.402l-1.266.554v-.003l-1.294.569-3.106 1.358a3.14 3.14 0 012.613-4.879zM14.036 18.863c-1.124 1.066-2.61 1.171-3.917.378l.738-1.123c.744.445 1.49.373 2.24-.216l.94.96zM15.315 18.085l-.008-5.936h1.124v5.776c0 .056.007.104.08.133l.978.38-.44 1.146-1.147-.485c-.434-.183-.587-.45-.587-1.014z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.55 17.986a1.788 1.788 0 01-.135-2.714l-.726-1.178a3.155 3.155 0 00.175 5.082l.685-1.19z",
    fill: "#2191C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.042 14.885a1.792 1.792 0 012.283 1.055l1.392-.117a3.16 3.16 0 00-4.256-2.18l.581 1.242z",
    fill: "#FAEC32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.438 16.658a1.792 1.792 0 01-2.226 1.65l-.546 1.265a3.158 3.158 0 004.138-2.872l-1.366-.043z",
    fill: "#D0362B"
  }));
};

SvgElo.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgElo.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgElo;